Vue.component('ppcarto-tripwizard',{
  template: `<transition name="fadeout"><div class="ppcarto-tripwizard" v-if="show && check" @click.self="submit()">
    <div class="modal">
      <header>
        <h1>Plan your individual journey</h1>
        <h2>by plane, train, bus or car</h2>
      </header>
      <form>
        <div class="group from">
          <ppcarto-typeahead ref="destination" :type="'origin'" :placeholder="'Start'" v-on:select="didSelect"></ppcarto-typeahead>
        </div>
        <div class="group to">
          <ppcarto-typeahead ref="destination" :type="'destination'" :placeholder="'Carinthia, Austria'" v-on:select="didSelect"></ppcarto-typeahead>
        </div>
        <div class="action">
          <a href="#" @click.prevent="submit">Go</div>
        </div>
      </form>
    </div>
  </div></transition>`,
  data(){
    return {
      origin: {},
      destination: {},
      show: true
    }
  },
  computed:{
    action(){
      return _.find(this.$store.getters.getActions, a => a.key == 'rome2rio');
    },
    check(){
        //return this.getUrlParameter('cartoParam');
        return true;
    }
  },
  methods: {
    getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    submit() {
      this.show = false;

      this.$store.commit('setRome2Rio', {
        origin: this.origin || null,
        destination: this.destination || null,
        from: this.origin.longName || null,
        to: this.destination.longName || null,
        visible: true
      })

      this.$store.commit('toggleAction', this.action);
    },
    didSelect(val){
      this[val.type] = val.place;
    }
  }

});
